import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { SettingsState } from 'reducers/settings';

const useSettings = (): SettingsState => {
  return useSelector((state: RootState) => state.settings);
};

export default useSettings;
